import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card } from "@/components/ui/card";
import { Lock } from "lucide-react";
import { toast } from "sonner";

export default function AdminLogin() {
  const navigate = useNavigate();
  const location = useLocation();
  const { loginAdmin, adminLoggedIn } = useAuth();
  const [form, setForm] = useState({ email: "admin@maaheyjewels.com", password: "" });
  const [loading, setLoading] = useState(false);

  // Already logged in (e.g. navigated back here manually) — skip the form and
  // go straight to where the guard originally redirected the user from.
  useEffect(() => {
    if (adminLoggedIn) navigate(location.state?.from || "/admin", { replace: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [adminLoggedIn]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/admin/login", form);
      loginAdmin(null, data.admin);
      toast.success("Welcome back");
      navigate(location.state?.from || "/admin", { replace: true });
    } catch (err) {
      // Fallback: try CRM staff (manager/salesman) login
      try {
        const { data } = await api.post("/crm/login", form);
        loginAdmin(null, { name: data.user.name, email: data.user.email });
        toast.success(`Welcome, ${data.user.name}`);
        navigate(location.state?.from || (data.user.is_manager ? "/crm/dashboard" : "/crm/daily-tasks"), { replace: true });
      } catch (e2) {
        toast.error(e2.response?.data?.detail || err.response?.data?.detail || "Login failed");
      }
    }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center hero-silk p-6">
      <Card className="w-full max-w-md p-8">
        <div className="flex items-center gap-2 text-[hsl(var(--primary))] mb-1"><Lock className="h-5 w-5" /><span className="text-sm uppercase tracking-widest">Admin Portal</span></div>
        <h1 className="font-display text-3xl mb-6">MAAHEY<span className="text-[hsl(var(--gold-dark))]">JEWELS</span> ERP</h1>
        <form onSubmit={submit} className="space-y-4">
          <div><Label htmlFor="email">Email</Label><Input id="email" data-testid="admin-email-input" type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="mt-1" /></div>
          <div><Label htmlFor="password">Password</Label><Input id="password" data-testid="admin-password-input" type="password" required value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} className="mt-1" /></div>
          <Button data-testid="admin-login-submit" type="submit" disabled={loading} className="w-full">{loading ? "Signing in..." : "Login"}</Button>
        </form>
      </Card>
    </div>
  );
}
